<table>
    <thead>
        <tr>
            <th class="subtable string">{{'mantenimientoConfecciones.tabs.envases.table.tabs.porcion.table.denominacion' | translate}}</th>
            <th class="subtable number">{{'mantenimientoConfecciones.tabs.envases.table.tabs.porcion.table.peso' | translate}}</th>
        </tr>
    </thead>
    <tbody *ngFor="let porcionEnvase of porcionesEnvase; let i = index">
        <tr>
            <td class="string">{{porcionEnvase.desDenominacion}}</td>
            <td class="number">{{porcionEnvase.kilos}}</td>
        </tr>
    </tbody>
    <tfoot *ngIf="!porcionesEnvase || (porcionesEnvase && porcionesEnvase.length < 1)">
        <tr>
          <td colspan="2">
            {{'global.noContent' | translate}}
          </td>
        </tr>
    </tfoot>
</table>